// extracted by mini-css-extract-plugin
module.exports = {"div":"LeftNav_div__ACCk3","logo":"LeftNav_logo__-HPy5"};